var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useParams } from "react-router-dom";
import React from "react";
export var rolDataForm = {
    id: "",
    clientId: "",
    RolName: "",
    RolDescription: "",
};
export var ColumnsPermissions = function (clickContextMenuPaymentMode) {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "type",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.DeleteForever,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Eliminar",
                        },
                    ], onClickContextMenu: function () {
                        return clickContextMenuPaymentMode(params === null || params === void 0 ? void 0 : params.row);
                    }, sizeIcon: sizesIcon.standard }) }))); },
        },
        {
            editable: false,
            field: "name",
            flex: 1,
            headerName: "Permiso",
            width: 150,
        },
        {
            editable: false,
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
    ];
};
